<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path d="M14,24l2,2L32,10,28,6,16,18,4,6,0,10Z" />
</svg>